import { render } from "./FeedBack.vue?vue&type=template&id=4864d4b8&scoped=true&lang=pug"
import script from "./FeedBack.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=4864d4b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4864d4b8"]])

export default __exports__